<template>
    <main class="main">
        <auth-form :inputs="inputs" :msgtext="msg" @toggle-password="togglePasswordVisibility"/>
        <img src="@/assets/Laptop.png" class="app_right">
    </main>
    <Loader  :show-loader="showLoader"/>
</template>

<script>

import AuthForm from "@/components/AuthForm";
import Functions from "@/assets/js/functions";
import Loader from "@/components/Loader.vue";

export default {
    name: 'App',
    components: {
        AuthForm,
        Loader
    },
    data() {
        return {
            inputs: [
                {name: "login", type: "text", text: "", placeholder: "Логин", onenter: false, action: false},
                {
                    name: "password",
                    type: "password",
                    text: "",
                    placeholder: "Пароль",
                    onenter: this.login,
                    action: false
                },
                {name: "button", type: "button", text: "Войти", placeholder: "", onenter: false, action: this.login}
            ],
            showPassword: false,
            showLoader: false,
            msg: ""
        }
    },
    methods: {
        login(item) {
            let s = this;
            s.showLoader = true;
            Functions.sync("authsystem", {
                login: this.inputs[0].text,
                password: this.inputs[1].text,
                api_key: "e9daa2e6-510c-47e6-8537-142293e9a9f9"
            }, function (json) {
                if (json.type == 'success') {
                    document.cookie = "token=" + json.data.token + "; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT"
                    document.location = 'http://cwsys.ru/';//ПОМЕНЯТЬ НА ПРОСТО ПАПКУ НАЗАД
                } else {
                    console.log(json);
                    s.msg = json.msg;
                    s.showLoader = false;
                }
            });
        },
        togglePasswordVisibility(showPassword) {
            this.showPassword = showPassword;
        },
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');
/* @font-face {
    font-family: 'Inter';
    src: url("./assets/fonts/Inter-Regular.ttf") format('truetype');
} */
#app {
    font-family: "Roboto";
    max-width: 100vw;
    overflow: hidden;
    max-height: 100vh;
    height: 100vh;
    width: 100vw;
}

.main {
    display: flex;
    align-items: center;
    height: 100vh;
    width: 100%;
    max-height: 100vh;
}
.app_right {
    margin-left: -20px;
    width: 100%;
    height: 100vh;
    border-radius: 20px 0 0 20px;
    /* object-fit: cover; */
}
*,
html * /* override x.xhtml.ru style */
{
    
    scrollbar-width: thin;
    scrollbar-color: blue orange;
}

*::-webkit-scrollbar,
html *::-webkit-scrollbar {
    height: 4px;
    width: 4px;
}

*::-webkit-scrollbar-track,
html *::-webkit-scrollbar-track {
    background: none;
}

*::-webkit-scrollbar-thumb,
html *::-webkit-scrollbar-thumb {
    border: 3px solid #767676;
    background: #767676;
    border-radius: 4px;
    width: 4px;
}

@media screen and (max-width: 850px) {
    #app {
    //background: url("@/assets/background-744.jpg") center center no-repeat;
    }

}
/* Reset and base styles  */
* {
	padding: 0px;
	margin: 0px;
	border: none;
}

*,
*::before,
*::after {
	box-sizing: border-box;
}

/* Links */

a, a:link, a:visited  {
    text-decoration: none;
}

a:hover  {
    text-decoration: none;
}

/* Common */

aside, nav, footer, header, section, main {
	display: block;
}

h1, h2, h3, h4, h5, h6, p {
    font-size: inherit;
	font-weight: inherit;
}

ul, ul li {
	list-style: none;
}

img {
	vertical-align: top;
}

img, svg {
	max-width: 100%;
	height: auto;
}

address {
  font-style: normal;
}

/* Form */

input, textarea, button, select {
	font-family: inherit;
    font-size: inherit;
    color: inherit;
    background-color: transparent;
}

input::-ms-clear {
	display: none;
}

button, input[type="submit"] {
    display: inline-block;
    box-shadow: none;
    background-color: transparent;
    background: none;
    cursor: pointer;
}

input:focus, input:active,
button:focus, button:active {
    outline: none;
}

button::-moz-focus-inner {
	padding: 0;
	border: 0;
}

label {
	cursor: pointer;
}

legend {
	display: block;
}

input[type='file'] {
	max-width: 100%;
}
@media(max-width:768px) {
    .app_right {
        display: none;
    }
    .form, .from_all {
        max-width: 450px!important;
        width: 100%!important;
    }
    .form {
        padding: 30px!important;
    }
    .text_grey {
        text-align: center!important;
    }
}
</style>
